import React from "react";
import { Link } from "react-router-dom";

function TermsOfService() {
  const scrollToSection = (event, sectionId) => {
    event.preventDefault();

    const element = document.getElementById(sectionId);
    const offset = 80;

    if (element) {
      const offsetPosition = element.offsetTop - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <section
      id="top"
      className="relative z-10 overflow-hidden py-16 md:py-[80px] xl:py-[100px]"
    >
      <div className="container">
        <h1 className="my-4 md:my-8 py-[40px] md:py-[120px] xl:py-[150px] text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-center text-black bg-slate-100/90 rounded">
          Terms of Service (TOS)
        </h1>
        <div className="-mx-4 pt-2 md:pt-4 flex flex-wrap">
          {/* Sidebar for Table of Contents */}
          <div className="hidden md:block md:w-1/4 lg:w-1/5 xl:w-1/6 pl-8 pr-4">
            <div className="sticky top-20">
              <h2 className="text-lg font-bold mb-4">Table of Contents</h2>
              <ul className="space-y-2 text-neutral-500">
                <li>
                  <a
                    href="#1"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "1")}
                  >
                    Overview of XplorEase
                  </a>
                </li>
                <li>
                  <a
                    href="#2"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "2")}
                  >
                    Acceptance of Terms
                  </a>
                </li>
                <li>
                  <a
                    href="#3"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "3")}
                  >
                    Account Creation Process
                  </a>
                </li>
                <li>
                  <a
                    href="#4"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "4")}
                  >
                    User Responsibilities and Conduct Guidelines
                  </a>
                </li>
                <li>
                  <a
                    href="#5"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "5")}
                  >
                    Rights Regarding the XplorEase Software and Content
                  </a>
                </li>
                <li>
                  <a
                    href="#6"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "6")}
                  >
                    User-Generated Content Policies
                  </a>
                </li>
                <li>
                  <a
                    href="#7"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "7")}
                  >
                    Disclaimer of Warranties
                  </a>
                </li>
                <li>
                  <a
                    href="#8"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "8")}
                  >
                    Limitation of Liability for Damages
                  </a>
                </li>
                <li>
                  <a
                    href="#9"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "9")}
                  >
                    Reference to the Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="#10"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "10")}
                  >
                    Procedures for Updating or Modifying the TOS
                  </a>
                </li>
                <li>
                  <a
                    href="#11"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "11")}
                  >
                    Jurisdiction and Applicable Law
                  </a>
                </li>
                <li>
                  <a
                    href="#12"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "11")}
                  >
                    Dispute Resolution Process
                  </a>
                </li>
                <li>
                  <a
                    href="#13"
                    className="hover:text-black"
                    onClick={(e) => scrollToSection(e, "11")}
                  >
                    How Users Can Contact XplorEase for Inquiries or Issues
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Main Content */}
          <div className="w-full md:w-3/4 lg:w-4/5 xl:w-5/6 px-4">
            <div
              className="wow fadeInUp mx-auto max-w-[800px]"
              data-wow-delay=".2s"
            >
              <h2
                id="1"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Overview of XplorEase
              </h2>
              <p className="mb-4 text-neutral-600">
                Welcome to XplorEase, your innovative chatbot solution designed
                to provide instant and comprehensive information about various
                locations via QR codes. XplorEase is tailored for travelers,
                researchers, and anyone interested in exploring their
                surroundings with ease. Our service does not require any
                downloads or installations, offering a seamless user experience.
              </p>

              <h2
                id="2"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Acceptance of Terms
              </h2>
              <p className="mb-4 text-neutral-600">
                By accessing and using XplorEase, you acknowledge that you have
                read, understood, and agree to be bound by these Terms of
                Service (TOS). If you do not agree with any part of these terms,
                you must not use our service.
              </p>

              <h2
                id="3"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Account Creation Process
              </h2>
              <p className="mb-4 text-neutral-600">
                To fully utilize XplorEase, users may be required to create an
                account. This process involves providing a valid email address
                and creating a password. Users must ensure that all information
                provided during the registration process is accurate and kept
                up-to-date.
              </p>

              <h2
                id="4"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                User Responsibilities and Conduct Guidelines
              </h2>
              <p className="mb-4 text-neutral-600">
                Users are responsible for maintaining the confidentiality of
                their account information and are fully accountable for all
                activities that occur under their account. XplorEase prohibits
                any conduct that is illegal, infringes upon the rights of
                others, or is harmful to others. This includes, but is not
                limited to, harassment, spreading malware, and conducting
                fraudulent activities.
              </p>

              <h2
                id="5"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Rights Regarding the XplorEase Software and Content
              </h2>
              <p className="mb-4 text-neutral-600">
                All rights, title, and interest in and to the XplorEase
                software, including all associated intellectual property rights,
                are and will remain the exclusive property of XplorEase and its
                licensors.
              </p>

              <h2
                id="6"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                User-Generated Content Policies
              </h2>
              <p className="mb-4 text-neutral-600">
                Users may be able to submit content or information through
                XplorEase. By submitting content, users grant XplorEase a
                non-exclusive, worldwide, royalty-free license to use,
                reproduce, distribute, and display this content in connection
                with the service. Limitation of Liability
              </p>

              <h2
                id="7"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Disclaimer of Warranties
              </h2>
              <p className="mb-4 text-neutral-600">
                XplorEase is provided on an "as is" and "as available" basis.
                We make no warranties, express or implied, regarding the
                operation or availability of the service.
              </p>

              <h2
                id="8"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Limitation of Liability for Damages
              </h2>
              <p className="mb-4 text-neutral-600">
                XplorEase and its affiliates, employees, agents, or licensors
                shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages, including but not limited
                to, loss of profits, data, use, goodwill, or other intangible
                losses, resulting from your access to or use of or inability to
                access or use the service.
              </p>

              <h2
                id="9"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Reference to the Privacy Policy
              </h2>
              <p className="mb-4 text-neutral-600">
                For information about how we collect, use, and share your
                information, please refer to our Privacy Policy.
              </p>

              <h2
                id="10"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Procedures for Updating or Modifying the TOS
              </h2>
              <p className="mb-4 text-neutral-600">
                We reserve the right to modify these terms at any time. We will
                notify users of any changes by posting the new TOS on this page
                and updating the "effective date" at the top of these terms.
                Users are advised to review these terms periodically for any
                changes.
              </p>

              <h2
                id="11"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Jurisdiction and Applicable Law
              </h2>
              <p className="mb-4 text-neutral-600">
                These terms shall be governed and construed in accordance with
                the laws of India, without regard to its conflict of law
                provisions.
              </p>

              <h2
                id="12"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                Dispute Resolution Process
              </h2>
              <p className="mb-4 text-neutral-600">
                In the event of a dispute, users agree to first contact us
                directly to seek a resolution. If we are not able to resolve the
                dispute, it may be required to be resolved by binding
                arbitration or in a court of competent jurisdiction in India.
              </p>

              <h2
                id="13"
                className="text-lg md:text-xl lg:text-2xl font-semibold mb-3"
              >
                How Users Can Contact XplorEase for Inquiries or Issues
              </h2>
              <p className="mb-4 text-neutral-600">
                If you have any questions about these Terms, please{" "}
                <Link
                  to="/support"
                  className="text-primary underline hover:text-primary-dark"
                >
                  contact us
                </Link>{" "}
                at{" "}
                <a
                  href="mailto:info@demetrix.in"
                  className="text-primary underline hover:text-primary-dark"
                >
                  info@demetrix.in
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute top-5 right-0 z-[-1]">
        <svg
          width="238"
          height="531"
          viewBox="0 0 238 531"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            opacity="0.3"
            x="422.819"
            y="-70.8145"
            width="196"
            height="541.607"
            rx="2"
            transform="rotate(51.2997 422.819 -70.8145)"
            fill="url(#paint0_linear_83:2)"
          />
          <rect
            opacity="0.3"
            x="426.568"
            y="144.886"
            width="59.7544"
            height="541.607"
            rx="2"
            transform="rotate(51.2997 426.568 144.886)"
            fill="url(#paint1_linear_83:2)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_83:2"
              x1="517.152"
              y1="-251.373"
              x2="517.152"
              y2="459.865"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" />
              <stop offset="1" stopColor="#4A6CF7" stopOpacity="0" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_83:2"
              x1="455.327"
              y1="-35.673"
              x2="455.327"
              y2="675.565"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" />
              <stop offset="1" stopColor="#4A6CF7" stopOpacity="0" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div className="absolute left-0 bottom-5 z-[-1]">
        <svg
          width="279"
          height="106"
          viewBox="0 0 279 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5">
            <path
              d="M-57 12L50.0728 74.8548C55.5501 79.0219 70.8513 85.7589 88.2373 79.3692C109.97 71.3821 116.861 60.9642 156.615 63.7423C178.778 65.291 195.31 69.2985 205.911 62.3533C216.513 55.408 224.994 47.7682 243.016 49.1572C255.835 50.1453 265.278 50.8936 278 45.3373"
              stroke="url(#paint0_linear_72:302)"
            />
            <path
              d="M-57 1L50.0728 63.8548C55.5501 68.0219 70.8513 74.7589 88.2373 68.3692C109.97 60.3821 116.861 49.9642 156.615 52.7423C178.778 54.291 195.31 58.2985 205.911 51.3533C216.513 44.408 224.994 36.7682 243.016 38.1572C255.835 39.1453 265.278 39.8936 278 34.3373"
              stroke="url(#paint1_linear_72:302)"
            />
            <path
              d="M-57 23L50.0728 85.8548C55.5501 90.0219 70.8513 96.7589 88.2373 90.3692C109.97 82.3821 116.861 71.9642 156.615 74.7423C178.778 76.291 195.31 80.2985 205.911 73.3533C216.513 66.408 224.994 58.7682 243.016 60.1572C255.835 61.1453 265.278 61.8936 278 56.3373"
              stroke="url(#paint2_linear_72:302)"
            />
            <path
              d="M-57 35L50.0728 97.8548C55.5501 102.022 70.8513 108.759 88.2373 102.369C109.97 94.3821 116.861 83.9642 156.615 86.7423C178.778 88.291 195.31 92.2985 205.911 85.3533C216.513 78.408 224.994 70.7682 243.016 72.1572C255.835 73.1453 265.278 73.8936 278 68.3373"
              stroke="url(#paint3_linear_72:302)"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_72:302"
              x1="256.267"
              y1="53.6717"
              x2="-40.8688"
              y2="8.15715"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_72:302"
              x1="256.267"
              y1="42.6717"
              x2="-40.8688"
              y2="-2.84285"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_72:302"
              x1="256.267"
              y1="64.6717"
              x2="-40.8688"
              y2="19.1572"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_72:302"
              x1="256.267"
              y1="76.6717"
              x2="-40.8688"
              y2="31.1572"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A6CF7" stopOpacity="0" />
              <stop offset="1" stopColor="#4A6CF7" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </section>
  );
}

export default TermsOfService;
